import axios from 'axios';

const API_BASE_URL = 'https://app.dhanapaljewellery.com/api/v1'

const ApiService = {
  addRate: async (rateData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/rate`, rateData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return response.data
    } catch (error) {
      throw error.response ? error.response.data : new Error('Network Error')
    }
  },
  getRates: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/rates`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return response.data
    } catch (error) {
      throw error.response ? error.response.data : new Error('Network Error')
    }
  },
  updateRate: async (id, rateData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/rate/${id}`, rateData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return response.data
    } catch (error) {
      throw error.response ? error.response.data : new Error('Network Error')
    }
  },
}

export default ApiService;
